// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-owner-step-body[data-v-7f5cbd24]{color:#858f9b;font-family:Inter;font-size:14px;font-weight:400}.info-block[data-v-7f5cbd24]{transition:margin-top .3s ease-in-out}.info-block--with-margin[data-v-7f5cbd24]{margin-top:30px}.owner-email-block[data-v-7f5cbd24]{margin-top:28px;padding-bottom:30px;height:136px}.owner-label[data-v-7f5cbd24]{padding-top:16px;text-align:left}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
